// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddMemberData, AddMemberErrors, AddMemberResponses, AddReceiptItemData, AddReceiptItemErrors, AddReceiptItemResponses, AnalyzeReceiptData, AnalyzeReceiptErrors, AnalyzeReceiptResponses, ApplyReceiptAnalysisData, ApplyReceiptAnalysisErrors, ApplyReceiptAnalysisResponses, ApplyReceiptItemsData, ApplyReceiptItemsErrors, ApplyReceiptItemsResponses, CancelReceiptMcpHandoffData, CancelReceiptMcpHandoffErrors, CancelReceiptMcpHandoffResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmReceiptData, ConfirmReceiptErrors, ConfirmReceiptResponses, ConvertReceiptCurrencyData, ConvertReceiptCurrencyErrors, ConvertReceiptCurrencyResponses, CreateGroupData, CreateGroupErrors, CreateGroupResponses, CreateMcpTokenData, CreateMcpTokenErrors, CreateMcpTokenResponses, CreateShareLinkData, CreateShareLinkErrors, CreateShareLinkResponses, CreateTransactionData, CreateTransactionErrors, CreateTransactionResponses, CreateUserData, CreateUserErrors, CreateUserResponses, DeleteGroupData, DeleteGroupErrors, DeleteGroupResponses, DeleteReceiptData, DeleteReceiptErrors, DeleteReceiptItemData, DeleteReceiptItemErrors, DeleteReceiptItemResponses, DeleteReceiptResponses, DeleteTransactionData, DeleteTransactionErrors, DeleteTransactionResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, ExportGroupData, ExportGroupErrors, ExportGroupResponses, GetCapabilitiesData, GetCapabilitiesErrors, GetCapabilitiesResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserResponses, GetGroupBalancesData, GetGroupBalancesErrors, GetGroupBalancesResponses, GetGroupData, GetGroupErrors, GetGroupResponses, GetGroupRevisionData, GetGroupRevisionErrors, GetGroupRevisionResponses, GetGroupSnapshotData, GetGroupSnapshotErrors, GetGroupSnapshotResponses, GetHealthData, GetHealthErrors, GetHealthResponses, GetMemberDebtsData, GetMemberDebtsErrors, GetMemberDebtsResponses, GetPaymentQrData, GetPaymentQrErrors, GetPaymentQrResponses, GetPublicGroupViewData, GetPublicGroupViewErrors, GetPublicGroupViewResponses, GetReceiptData, GetReceiptErrors, GetReceiptFileData, GetReceiptFileErrors, GetReceiptFileResponses, GetReceiptResponses, GetReceiptTranslationFileData, GetReceiptTranslationFileErrors, GetReceiptTranslationFileResponses, GetTransactionData, GetTransactionErrors, GetTransactionResponses, ListCurrenciesData, ListCurrenciesErrors, ListCurrenciesResponses, ListGroupsData, ListGroupsErrors, ListGroupsResponses, ListMcpTokensData, ListMcpTokensErrors, ListMcpTokensResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListReceiptAnalysesData, ListReceiptAnalysesErrors, ListReceiptAnalysesResponses, ListReceiptsData, ListReceiptsErrors, ListReceiptsResponses, ListShareLinksData, ListShareLinksErrors, ListShareLinksResponses, ListTransactionsData, ListTransactionsErrors, ListTransactionsResponses, ListUnattachedReceiptsData, ListUnattachedReceiptsErrors, ListUnattachedReceiptsResponses, ListUsersData, ListUsersErrors, ListUsersResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutResponses, RemoveMemberData, RemoveMemberErrors, RemoveMemberResponses, RevokeMcpTokenData, RevokeMcpTokenErrors, RevokeMcpTokenResponses, RevokeShareLinkData, RevokeShareLinkErrors, RevokeShareLinkResponses, SuggestExchangeRateData, SuggestExchangeRateErrors, SuggestExchangeRateResponses, TranslateReceiptData, TranslateReceiptErrors, TranslateReceiptResponses, UpdateGroupData, UpdateGroupErrors, UpdateGroupResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberResponses, UpdateOwnProfileData, UpdateOwnProfileErrors, UpdateOwnProfileResponses, UpdateReceiptData, UpdateReceiptErrors, UpdateReceiptItemData, UpdateReceiptItemErrors, UpdateReceiptItemResponses, UpdateReceiptResponses, UpdateTransactionData, UpdateTransactionErrors, UpdateTransactionResponses, UpdateUserData, UpdateUserErrors, UpdateUserResponses, UploadGroupReceiptsData, UploadGroupReceiptsErrors, UploadGroupReceiptsResponses, UploadReceiptData, UploadReceiptErrors, UploadReceiptResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Stav aplikace a databáze
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({
        url: '/health',
        ...options
    });
};

/**
 * Dostupné volitelné funkce instalace
 */
export const getCapabilities = <ThrowOnError extends boolean = false>(options?: Options<GetCapabilitiesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCapabilitiesResponses, GetCapabilitiesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/capabilities',
        ...options
    });
};

/**
 * Přihlášení uživatele
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => {
    return (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Odhlášení uživatele
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => {
    return (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
        url: '/auth/logout',
        ...options
    });
};

/**
 * Profil přihlášeného uživatele
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/me',
        ...options
    });
};

/**
 * Změna vlastního hesla
 *
 * Po úspěšné změně jsou zneplatněna všechna ostatní přihlášení uživatele.
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Změna vlastních platebních údajů
 */
export const updateOwnProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateOwnProfileData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateOwnProfileResponses, UpdateOwnProfileErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Přístupové tokeny přihlášeného uživatele pro AI asistenta (MCP)
 */
export const listMcpTokens = <ThrowOnError extends boolean = false>(options?: Options<ListMcpTokensData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListMcpTokensResponses, ListMcpTokensErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/mcp-tokens',
        ...options
    });
};

/**
 * Vytvoření přístupového tokenu pro AI asistenta (MCP)
 *
 * Asistent se tokenem prokazuje v hlavičce `Authorization: Bearer <token>`
 * při volání `/api/mcp` a jedná s oprávněními uživatele, který token vytvořil.
 * Celý token se vrací jen v této odpovědi.
 *
 */
export const createMcpToken = <ThrowOnError extends boolean = false>(options: Options<CreateMcpTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateMcpTokenResponses, CreateMcpTokenErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/mcp-tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Zrušení přístupového tokenu pro AI asistenta
 *
 * Asistent, který token používá, se tím okamžitě odpojí.
 */
export const revokeMcpToken = <ThrowOnError extends boolean = false>(options: Options<RevokeMcpTokenData, ThrowOnError>) => {
    return (options.client ?? client).delete<RevokeMcpTokenResponses, RevokeMcpTokenErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/auth/mcp-tokens/{tokenId}',
        ...options
    });
};

/**
 * Seznam uživatelů
 *
 * Pouze pro administrátora.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/users',
        ...options
    });
};

/**
 * Založení uživatele
 *
 * Pouze pro administrátora - samoobslužná registrace neexistuje.
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Smazání uživatele
 *
 * Pouze pro administrátora. Uživatele navázaného na člena skupiny nelze smazat -
 * místo toho se deaktivuje.
 *
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/users/{userId}',
        ...options
    });
};

/**
 * Úprava uživatele
 *
 * Pouze pro administrátora.
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/users/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Číselník podporovaných měn
 */
export const listCurrencies = <ThrowOnError extends boolean = false>(options?: Options<ListCurrenciesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCurrenciesResponses, ListCurrenciesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/currencies',
        ...options
    });
};

/**
 * Skupiny přihlášeného uživatele
 *
 * Administrátor vidí všechny skupiny, běžný uživatel jen ty, kde je členem.
 */
export const listGroups = <ThrowOnError extends boolean = false>(options?: Options<ListGroupsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListGroupsResponses, ListGroupsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups',
        ...options
    });
};

/**
 * Založení skupiny
 *
 * Pouze pro administrátora.
 */
export const createGroup = <ThrowOnError extends boolean = false>(options: Options<CreateGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateGroupResponses, CreateGroupErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Smazání skupiny včetně všech jejích dat
 *
 * Pouze pro administrátora.
 */
export const deleteGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteGroupData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}',
        ...options
    });
};

/**
 * Detail skupiny včetně členů
 */
export const getGroup = <ThrowOnError extends boolean = false>(options: Options<GetGroupData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGroupResponses, GetGroupErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}',
        ...options
    });
};

/**
 * Úprava skupiny
 *
 * Pouze pro administrátora.
 */
export const updateGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateGroupData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Členové skupiny
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>) => {
    return (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/members',
        ...options
    });
};

/**
 * Přidání člena do skupiny
 *
 * Pouze pro administrátora. Člen nemusí mít uživatelský účet.
 */
export const addMember = <ThrowOnError extends boolean = false>(options: Options<AddMemberData, ThrowOnError>) => {
    return (options.client ?? client).post<AddMemberResponses, AddMemberErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Odebrání člena ze skupiny
 *
 * Pouze pro administrátora. Člena, který má v historii nějaký pohyb, nelze
 * odebrat - místo toho se deaktivuje.
 *
 */
export const removeMember = <ThrowOnError extends boolean = false>(options: Options<RemoveMemberData, ThrowOnError>) => {
    return (options.client ?? client).delete<RemoveMemberResponses, RemoveMemberErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/members/{memberId}',
        ...options
    });
};

/**
 * Úprava člena skupiny
 *
 * Pouze pro administrátora.
 */
export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/members/{memberId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Historie pohybů ve skupině
 *
 * Výchozí řazení je podle data od nejnovějších.
 */
export const listTransactions = <ThrowOnError extends boolean = false>(options: Options<ListTransactionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListTransactionsResponses, ListTransactionsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/transactions',
        ...options
    });
};

/**
 * Přidání pohybu
 */
export const createTransaction = <ThrowOnError extends boolean = false>(options: Options<CreateTransactionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateTransactionResponses, CreateTransactionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/transactions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Doporučený kurz do hlavní měny skupiny
 *
 * Vrací kurz ČNB k zadanému datu; slouží k předvyplnění formuláře.
 */
export const suggestExchangeRate = <ThrowOnError extends boolean = false>(options: Options<SuggestExchangeRateData, ThrowOnError>) => {
    return (options.client ?? client).get<SuggestExchangeRateResponses, SuggestExchangeRateErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/exchange-rate',
        ...options
    });
};

/**
 * Smazání pohybu
 */
export const deleteTransaction = <ThrowOnError extends boolean = false>(options: Options<DeleteTransactionData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTransactionResponses, DeleteTransactionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transactionId}',
        ...options
    });
};

/**
 * Detail pohybu
 */
export const getTransaction = <ThrowOnError extends boolean = false>(options: Options<GetTransactionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTransactionResponses, GetTransactionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transactionId}',
        ...options
    });
};

/**
 * Úprava pohybu
 *
 * Vyžaduje aktuální `version`; při souběžné změně vrací 409.
 */
export const updateTransaction = <ThrowOnError extends boolean = false>(options: Options<UpdateTransactionData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateTransactionResponses, UpdateTransactionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transactionId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fronta účtenek skupiny čekajících na spárování s pohybem
 *
 * Vrací účtenky nahrané do skupiny, které zatím nepatří k žádnému pohybu -
 * tedy frontu ke spárování. Zůstávají v ní i po zavření dialogu nového pohybu,
 * obnovení stránky nebo restartu serveru; uklidí se až po týdnu.
 *
 * Klient se na seznam doptává, dokud u některé účtenky běží rozpoznávání.
 *
 */
export const listUnattachedReceipts = <ThrowOnError extends boolean = false>(options: Options<ListUnattachedReceiptsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListUnattachedReceiptsResponses, ListUnattachedReceiptsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/receipts',
        ...options
    });
};

/**
 * Nahrání účtenek před založením pohybu
 *
 * Přijme jednu nebo více účtenek (fotografie, sken nebo PDF) a u každé hned
 * zařadí rozpoznávání do fronty na pozadí. Účtenky zatím nepatří k žádnému
 * pohybu - připojí se k němu až jeho založením nebo úpravou s uvedeným
 * `receiptIds`.
 *
 * Rozpoznávání běží nezávisle na klientovi: doběhne, i když uživatel zavře
 * dialog, obnoví stránku nebo prohlížeč, a po restartu serveru se
 * nedokončené zpracování obnoví.
 *
 * Bez `receiptIndexes` je každý soubor samostatná účtenka. S ním se soubory
 * seskupí: soubory se stejným číslem tvoří jednu účtenku o několika fotkách
 * (v pořadí, v jakém přišly), takže rozpoznávání i asistent dostanou všechny
 * fotky dlouhé účtenky najednou. Účtenky jsou v odpovědi v pořadí, v jakém se
 * jejich číslo poprvé objevilo.
 *
 * S `analysisMode=MCP` se rozpoznávání na serveru nespustí - účtenky
 * dostanou stav `AWAITING_MCP` a počkají, až si je vyzvedne AI asistent
 * uživatele přes MCP.
 *
 * Obrázky se překódují (zahodí se EXIF včetně polohy), z PDF se bere první
 * stránka.
 *
 */
export const uploadGroupReceipts = <ThrowOnError extends boolean = false>(options: Options<UploadGroupReceiptsData, ThrowOnError>) => {
    return (options.client ?? client).post<UploadGroupReceiptsResponses, UploadGroupReceiptsErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/receipts',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Účtenky připojené k pohybu
 */
export const listReceipts = <ThrowOnError extends boolean = false>(options: Options<ListReceiptsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListReceiptsResponses, ListReceiptsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transactionId}/receipts',
        ...options
    });
};

/**
 * Nahrání fotografie účtenky
 *
 * Obrázek se na serveru překóduje - tím se zahodí EXIF (včetně polohy)
 * a ověří se, že jde skutečně o fotografii.
 *
 */
export const uploadReceipt = <ThrowOnError extends boolean = false>(options: Options<UploadReceiptData, ThrowOnError>) => {
    return (options.client ?? client).post<UploadReceiptResponses, UploadReceiptErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/transactions/{transactionId}/receipts',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Smazání účtenky
 */
export const deleteReceipt = <ThrowOnError extends boolean = false>(options: Options<DeleteReceiptData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteReceiptResponses, DeleteReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}',
        ...options
    });
};

/**
 * Detail účtenky včetně položek
 */
export const getReceipt = <ThrowOnError extends boolean = false>(options: Options<GetReceiptData, ThrowOnError>) => {
    return (options.client ?? client).get<GetReceiptResponses, GetReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}',
        ...options
    });
};

/**
 * Úprava údajů účtenky
 */
export const updateReceipt = <ThrowOnError extends boolean = false>(options: Options<UpdateReceiptData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateReceiptResponses, UpdateReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Obrázek účtenky
 *
 * Soubory se vydávají jen přihlášeným členům skupiny, ne ze statického adresáře.
 */
export const getReceiptFile = <ThrowOnError extends boolean = false>(options: Options<GetReceiptFileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetReceiptFileResponses, GetReceiptFileErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/file',
        ...options
    });
};

/**
 * Přidání položky účtenky
 */
export const addReceiptItem = <ThrowOnError extends boolean = false>(options: Options<AddReceiptItemData, ThrowOnError>) => {
    return (options.client ?? client).post<AddReceiptItemResponses, AddReceiptItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/items',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Smazání položky účtenky
 */
export const deleteReceiptItem = <ThrowOnError extends boolean = false>(options: Options<DeleteReceiptItemData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteReceiptItemResponses, DeleteReceiptItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/items/{itemId}',
        ...options
    });
};

/**
 * Úprava položky účtenky
 */
export const updateReceiptItem = <ThrowOnError extends boolean = false>(options: Options<UpdateReceiptItemData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateReceiptItemResponses, UpdateReceiptItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/items/{itemId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Promítnutí položek do podílů pohybu
 *
 * Cena každé položky se rozdělí rovným dílem mezi přiřazené osoby a součty
 * za osobu se uloží jako podíly pohybu. Vyžaduje, aby měla každá položka
 * přiřazenou aspoň jednu osobu a aby součet položek odpovídal částce pohybu.
 *
 */
export const applyReceiptItems = <ThrowOnError extends boolean = false>(options: Options<ApplyReceiptItemsData, ThrowOnError>) => {
    return (options.client ?? client).post<ApplyReceiptItemsResponses, ApplyReceiptItemsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/apply',
        ...options
    });
};

/**
 * Přepočet účtenky do hlavní měny skupiny
 *
 * Účtenka rozpoznaná v měně, kterou skupina nepoužívá, se přepočte do hlavní
 * měny skupiny dnešním kurzem ČNB - celková částka i ceny položek. Součet
 * přepočtených položek odpovídá přepočtenému součtu původních položek.
 * Jen pro účtenky, které ještě nepatří k žádnému pohybu.
 *
 */
export const convertReceiptCurrency = <ThrowOnError extends boolean = false>(options: Options<ConvertReceiptCurrencyData, ThrowOnError>) => {
    return (options.client ?? client).post<ConvertReceiptCurrencyResponses, ConvertReceiptCurrencyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/convert-currency',
        ...options
    });
};

/**
 * Potvrzení účtenky (založení útraty) nebo uložení úpravy útraty z účtenky
 *
 * Účtenka nahraná do skupiny čeká ve frontě, dokud ji uživatel nezkontroluje.
 * Potvrzením z ní vznikne útrata - rozdělená podle přiřazených položek, nebo
 * rovným dílem - a účtenka se k ní připojí (201). Případné čekání na AI
 * asistenta se tím ukončí.
 *
 * U účtenky, která už k útratě patří, se stejným požadavkem uloží úprava té
 * útraty (200); údaje, které požadavek neobsahuje, zůstanou, jak byly.
 * Účtenku, kterou server právě rozpoznává, potvrdit ani uložit nejde.
 *
 */
export const confirmReceipt = <ThrowOnError extends boolean = false>(options: Options<ConfirmReceiptData, ThrowOnError>) => {
    return (options.client ?? client).post<ConfirmReceiptResponses, ConfirmReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ukončení čekání na AI asistenta
 *
 * Účtenka předaná AI asistentovi přes MCP čeká, dokud ji asistent nezpracuje.
 * Když ho uživatel spouštět nechce, čekání tímto ukončí - účtenka zůstane
 * s tím, co rozpoznal server, případně se údaje doplní ručně.
 *
 */
export const cancelReceiptMcpHandoff = <ThrowOnError extends boolean = false>(options: Options<CancelReceiptMcpHandoffData, ThrowOnError>) => {
    return (options.client ?? client).delete<CancelReceiptMcpHandoffResponses, CancelReceiptMcpHandoffErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/mcp-handoff',
        ...options
    });
};

/**
 * Spuštění rozpoznání položek z účtenky
 *
 * Rozpoznávání běží na pozadí - endpoint hned vrací účtenku ve stavu PENDING
 * a klient si výsledek dotáhne opakovaným dotazem na detail účtenky.
 *
 * Rozpoznané položky nahradí dosavadní obsah účtenky a slouží jen jako návrh
 * k ruční kontrole.
 *
 * Slouží i jako „přečíst znovu", když se rozpoznání nepovedlo: výsledek,
 * který přijde po téhle žádosti, nahradí dosavadní položky.
 *
 * S `analysisMode=MCP` se účtenka místo rozpoznání na serveru předá AI
 * asistentovi přes MCP (stav `AWAITING_MCP`). S `analysisMode=BOTH` ji
 * rozpozná server i asistent - první hotový výsledek se použije, druhý čeká
 * k porovnání. Účtenku, kterou server právě rozpoznává, znovu zadat nejde.
 *
 */
export const analyzeReceipt = <ThrowOnError extends boolean = false>(options: Options<AnalyzeReceiptData, ThrowOnError>) => {
    return (options.client ?? client).post<AnalyzeReceiptResponses, AnalyzeReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/analyze',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Výsledky rozpoznání účtenky k porovnání
 *
 * Každé rozpoznání účtenky - na serveru i od AI asistenta přes MCP - se
 * ukládá zvlášť, od nejnovějšího. Do položek účtenky se promítá jen ten
 * s `isApplied`; ostatní jde porovnat a případně použít.
 *
 */
export const listReceiptAnalyses = <ThrowOnError extends boolean = false>(options: Options<ListReceiptAnalysesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListReceiptAnalysesResponses, ListReceiptAnalysesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/analyses',
        ...options
    });
};

/**
 * Použití vybraného výsledku rozpoznání
 *
 * Promítne vybraný výsledek do položek účtenky - nahradí položky i s
 * přiřazením osob, název obchodu, celkovou částku a datum.
 *
 */
export const applyReceiptAnalysis = <ThrowOnError extends boolean = false>(options: Options<ApplyReceiptAnalysisData, ThrowOnError>) => {
    return (options.client ?? client).post<ApplyReceiptAnalysisResponses, ApplyReceiptAnalysisErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/analyses/{analysisId}/apply',
        ...options
    });
};

/**
 * Překlad účtenky do češtiny nebo angličtiny
 *
 * Na vstupu je fotografie účtenky v cizím jazyce, na výstupu tatáž fotografie
 * s přeloženým textem na stejných místech. Překlad slouží jen ke čtení -
 * nikdy se nepoužívá jako podklad pro výpočty.
 *
 */
export const translateReceipt = <ThrowOnError extends boolean = false>(options: Options<TranslateReceiptData, ThrowOnError>) => {
    return (options.client ?? client).post<TranslateReceiptResponses, TranslateReceiptErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/translate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Obrázek přeložené účtenky
 */
export const getReceiptTranslationFile = <ThrowOnError extends boolean = false>(options: Options<GetReceiptTranslationFileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetReceiptTranslationFileResponses, GetReceiptTranslationFileErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/receipts/{receiptId}/translation/{targetLang}/file',
        ...options
    });
};

/**
 * Bilance členů a návrhy úhrad
 *
 * Vrací obě varianty vypořádání najednou - párové dluhy podle historie
 * i minimalizované převody - aby přepínač v aplikaci fungoval bez dalšího dotazu.
 *
 */
export const getGroupBalances = <ThrowOnError extends boolean = false>(options: Options<GetGroupBalancesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGroupBalancesResponses, GetGroupBalancesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/balances',
        ...options
    });
};

/**
 * Platební QR kód pro úhradu dluhu
 *
 * Vytvoří QR platbu ve prospěch zadaného člena skupiny. Podmínkou je, že člen
 * má navázaný uživatelský účet s vyplněným číslem účtu a že mu skupina
 * skutečně dluží alespoň požadovanou částku.
 *
 * Kód se nikam neukládá - vzniká až při tomto volání, takže vždy odpovídá
 * aktuální bilanci skupiny.
 *
 */
export const getPaymentQr = <ThrowOnError extends boolean = false>(options: Options<GetPaymentQrData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentQrResponses, GetPaymentQrErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/payment-qr',
        ...options
    });
};

/**
 * Za co člen dluží - pohyby a položky, ze kterých vzniká jeho bilance
 *
 * Pohyby skupiny, kterých se člen účastní (od nejnovějšího), s tím, kolik
 * zaplatil a kolik na něj připadá, komu z jeho podílu dluží a kdo dluží
 * jemu, a u útrat z účtenky položky, které na něj připadly. Součty `owesTo`
 * a `owedBy` přes všechny pohyby odpovídají párovým dluhům ze `/balances`.
 *
 */
export const getMemberDebts = <ThrowOnError extends boolean = false>(options: Options<GetMemberDebtsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetMemberDebtsResponses, GetMemberDebtsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/members/{memberId}/debts',
        ...options
    });
};

/**
 * Export historie skupiny
 *
 * CSV je připravené pro tabulkový procesor (oddělovač středník, kódování
 * UTF-8 s BOM), JSON obsahuje kompletní data včetně položek účtenek.
 *
 */
export const exportGroup = <ThrowOnError extends boolean = false>(options: Options<ExportGroupData, ThrowOnError>) => {
    return (options.client ?? client).get<ExportGroupResponses, ExportGroupErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/export.{format}',
        ...options
    });
};

/**
 * Odkazy na veřejný náhled skupiny
 *
 * Pouze pro administrátora. Tajná část odkazu se už nevrací.
 */
export const listShareLinks = <ThrowOnError extends boolean = false>(options: Options<ListShareLinksData, ThrowOnError>) => {
    return (options.client ?? client).get<ListShareLinksResponses, ListShareLinksErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/share-links',
        ...options
    });
};

/**
 * Vytvoření odkazu na veřejný náhled
 *
 * Pouze pro administrátora. Odpověď obsahuje token - jindy už ho nelze zobrazit.
 */
export const createShareLink = <ThrowOnError extends boolean = false>(options: Options<CreateShareLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateShareLinkResponses, CreateShareLinkErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/share-links',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Zrušení odkazu na veřejný náhled
 *
 * Pouze pro administrátora. Odkaz okamžitě přestane fungovat.
 */
export const revokeShareLink = <ThrowOnError extends boolean = false>(options: Options<RevokeShareLinkData, ThrowOnError>) => {
    return (options.client ?? client).delete<RevokeShareLinkResponses, RevokeShareLinkErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/share-links/{shareLinkId}',
        ...options
    });
};

/**
 * Veřejný náhled skupiny podle odkazu
 *
 * Nevyžaduje přihlášení. Vrací jen data ke čtení, bez účtenek a účtů.
 */
export const getPublicGroupView = <ThrowOnError extends boolean = false>(options: Options<GetPublicGroupViewData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPublicGroupViewResponses, GetPublicGroupViewErrors, ThrowOnError>({
        url: '/public/{token}',
        ...options
    });
};

/**
 * Kompletní stav skupiny pro cache klienta
 */
export const getGroupSnapshot = <ThrowOnError extends boolean = false>(options: Options<GetGroupSnapshotData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGroupSnapshotResponses, GetGroupSnapshotErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/snapshot',
        ...options
    });
};

/**
 * Aktuální číslo verze dat skupiny
 */
export const getGroupRevision = <ThrowOnError extends boolean = false>(options: Options<GetGroupRevisionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGroupRevisionResponses, GetGroupRevisionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'splitup_session',
                type: 'apiKey'
            }
        ],
        url: '/groups/{groupId}/revision',
        ...options
    });
};
